import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import * as additionalComponents from "./__components";
import { blog_helper } from "@/helpers/blog_helper";
import { createTitle } from "@/functions/createTitle";
import { jobs_helper } from "@/helpers/jobs_helper";

export default function BlogPostPage({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const page = blog_helper.find(url_slug);
  const related = blog_helper.fetch({
    limit: 3,
    // filter: (r) =>
    //   Array.isArray(page.tags) && Array.isArray(r.tags) ? page.tags.some((t) => r.tags.includes(t)) : false,
  });
  const jobs = jobs_helper.fetch({ limit: 3 });

  return {
    props: {
      meta: {
        title: createTitle(page.title, "Blog"),
      },
      content: [
        // {
        //   component: "BreadcrumbNavigation",
        //   props: {
        //     items: [
        //       { label: "Blog", href: getRoute("blog") },
        //       { label: page.title, href: getRoute("blogPost", { url_slug }) },
        //     ],
        //   },
        // },
        { component: "BlogArticleContent", props: { ...page, related, jobs } },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: blog_helper.toPaths(),
    fallback: false,
  };
}
